var map = {
	"./5-CN.png": "SibG",
	"./5-EN.png": "d1s/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X1jg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m ^\.\/5\-.*\.png$
// module id = X1jg
// module chunks = 1